<template>
    <article class="i-events-card">
        <div class="i-events-card__header">
            <h2
                class="i-events-card__breadcrumb"
                :title="card.category"
                v-html="card.category"></h2>
            <div
                class="i-events-card__date"
                v-html="card.date"></div>
        </div>
        <h3
            class="i-events-card__title"
            :title="card.name"
            v-html="card.name"></h3>
        <div class="i-events-card__footer">
            <a
                class="i-events-card__download"
                :href="apiUrl + card.id + '/'"
                title="Добавить в календарь"
                :download="card.name"
                v-html="'Добавить в календарь'"></a>
            <a
                class="i-events-card__link"
                :href="card.link"
                title="Подробнее">
                <span v-html="'Подробнее'"></span>
                <span class="i-events-card__arrow"></span>                
            </a>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'EventsCard',
        data() {
            return {
                apiUrl: '/api/v2/content/investors/calendarics/'
            }
        },
        props: {
            card: {
                type: Object,
                default: () => {}
            }
        },
    }
</script>